// extracted by mini-css-extract-plugin
module.exports = {"noResult__wrapper":"noResult__wrapper"};